import { render, staticRenderFns } from "./FinishMessage.vue?vue&type=template&id=7ed10fe4&scoped=true&"
var script = {}
import style0 from "./FinishMessage.vue?vue&type=style&index=0&id=7ed10fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed10fe4",
  null
  
)

export default component.exports